import { Button, Form, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Children, FC, Fragment, isValidElement, cloneElement, ReactNode } from 'react';
import { PortalModalNew } from '../../modals/modals-new';
import * as Styles from './filter-new.module.less';

interface ExtendedFilterFormNewProps {
    mobile: boolean;
    children?: ReactNode;
}

const ExtendedFilterFormNew: FC<ExtendedFilterFormNewProps> = observer(props => {
    const { children, mobile } = props;

    const childrenWithProps = Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a typescript error too.
        if (isValidElement(child)) {
            return cloneElement(child, {
                ...child.props,
                mobile,
                className: classNames(
                    Styles.formItem,
                    mobile ? Styles.formTakeoverItem : Styles.formModalItem,
                    child.props.className
                ),
            } as any);
        }
        return child;
    });

    return (
        <Form className={mobile ? Styles.formTakeover : Styles.formModal}>{childrenWithProps}</Form>
    );
});

export interface PortalFilterNewProps {
    mobile: boolean;
    open?: boolean;
    title?: string;
    hasAny: boolean;
    children?: ReactNode;
    apply(): void;
    cancel(): void;
    clear(): void;
}

export const PortalFilterNew: FC<PortalFilterNewProps> = props => {
    const { apply, cancel, children, clear, hasAny, mobile, open, title } = props;

    const modalTitle = mobile ? 'Filters' : 'Edit Filters';
    return (
        <PortalModalNew
            mobile={mobile}
            title={title ?? modalTitle}
            open={open ?? false}
            onClose={cancel}
            footerAlign="space-between"
            takeover={{
                backLabel: '',
                theme: 'grey',
                actions: (
                    <Button size="small" fill="subtle" onClick={clear} primary>
                        Reset All
                    </Button>
                ),
            }}
            footer={
                <Fragment>
                    <Stack.Item fill>
                        <Button fill="subtle" onClick={clear} disabled={!hasAny} primary>
                            Clear All
                        </Button>
                    </Stack.Item>
                    <Button
                        className={classNames('m-r-1', { 'flex-grow-1 flex-basis-0': mobile })}
                        onClick={cancel}
                        fill="subtle"
                    >
                        Cancel
                    </Button>
                    <Button
                        className={classNames('m-l-1', { 'flex-grow-1 flex-basis-0': mobile })}
                        onClick={apply}
                        primary
                    >
                        Apply
                    </Button>
                </Fragment>
            }
        >
            <ExtendedFilterFormNew mobile={mobile}>{children}</ExtendedFilterFormNew>
        </PortalModalNew>
    );
};
